// const baseURL = 'https://solutions.api-services.cloud/api-ccpisa-appointments/'
const baseUrl = process.env.NODE_ENV === 'production' ?
    'https://appuntamenti.tno.camcom.it/api/' :
    'https://d3w004aeup5lbw.cloudfront.net/api/'
    // 'http://ec2-54-154-94-164.eu-west-1.compute.amazonaws.com:3001/'

export const getOffices = (): string => {
    return baseUrl + 'offices?hq=true'
}

export const getServices = (officeId: number): string => {
    return baseUrl + 'offices/' + officeId + '/services'
}

export const getServiceTimeSlots = (serviceId: number, startDate: string, endDate: string): string => {
    return baseUrl + 'services/' + serviceId + '/slots?start_date=' + startDate + '&end_date=' + endDate
}

export const createEvent = (): string => {
    return baseUrl + 'reservations'
}

export const checkReCaptcha = (): string => {
    return baseUrl + 'recaptcha'
}

export const getEmailTemplateInfo = (): string => {
    return baseUrl + 'conf'
}

export const getUserAppoinments = (): string => {
    return baseUrl + 'appointments?active=true'
}

export const removeUserAppointment = (idAppointment: string): string => {
    return baseUrl + '/reservations/' + idAppointment
}
